import PlaceholderImage from '@assets/images/context2.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './AboutUsOne.style';
import { useTranslation } from 'react-i18next';

const AboutUsOne = () => {
  const { t } = useTranslation('aboutUs');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>
          {t('aboutUsOne.title.spanBefore')}
          <span>2</span> {t('aboutUsOne.title.spanAfter')}
        </h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox2>
          <p>
            {t('aboutUsOne.paragraphOne')}
            <br />
            <br /> {t('aboutUsOne.paragraphTwo')}
            <br />
            <br />
            {t('aboutUsOne.paragraphThree')}
            <br />
            <br />
            {t('aboutUsOne.paragraphFour')}
          </p>
        </TextBox2>
        <ImageBox>
          <img src={PlaceholderImage} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default AboutUsOne;
